import { createStore, applyMiddleware } from 'redux';
import { Reducers } from '../reducers';
import thunkMiddleware from 'redux-thunk'

export const Store = createStore(Reducers,applyMiddleware(
    thunkMiddleware, // lets us dispatch() functions
));